import { useMsal } from "@azure/msal-react";

export type UseCurrentUserReturn = {
    userGivenName: string
    userFamilyName: string
    email: string
}

const useCurrentUser = (): UseCurrentUserReturn => {
    const { accounts } = useMsal();

    const idTokenClaims = accounts.length > 0 ? accounts[0].idTokenClaims : undefined;
    
    return {
        userGivenName: idTokenClaims?.given_name as string || "",
        userFamilyName: idTokenClaims?.family_name as string || "",
        email: idTokenClaims?.email as string || "",
    };
};

export default useCurrentUser;